import { render } from "./AccoountsPeopleList.vue?vue&type=template&id=7137667a"
import script from "./AccoountsPeopleList.vue?vue&type=script&lang=js"
export * from "./AccoountsPeopleList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__